// What the Generate Simulation page shows under Start Simulation while a run
// is going. The sim writes a few log lines before and after the solve and
// nothing during it, so without this the page looks frozen for most of a run.

export const RUN_STATUS_MESSAGE =
  "Simulation running. The log stays quiet while the optimizer works; that is normal. " +
  "A full simulated year takes from a couple of minutes to 20+ minutes. " +
  "You can go Back to Simulations and find the results there when the run finishes.";

const pad2 = (n) => String(n).padStart(2, "0");

/**
 * Formats a run's elapsed whole seconds as "m:ss", or "h:mm:ss" from an hour
 * on: 0 -> "0:00", 65 -> "1:05", 3725 -> "1:02:05". Fractions are dropped;
 * a negative or non-numeric value reads as 0.
 */
export const formatElapsed = (seconds) => {
  const total =
    typeof seconds === "number" && Number.isFinite(seconds) && seconds > 0
      ? Math.floor(seconds)
      : 0;
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  return hours > 0
    ? `${hours}:${pad2(minutes)}:${pad2(secs)}`
    : `${minutes}:${pad2(secs)}`;
};
